export default __webpack_public_path__ + "static/media/storiesHero.1a4a27a7.jpg";